import * as React from 'react'
import UnstyledSelect, { Props } from 'react-select'
import UnstyledCreatable from 'react-select/creatable'
import UnstyledAsync from 'react-select/async'
import { DefaultTheme } from 'styled-components'
import { injectTheme } from '../../theme'
import { Props as StateManagerProps } from 'react-select'
import { I18nService } from '../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./select.component.yml'))

function getStyleOverrides (props: StateManagerProps & { theme?: DefaultTheme }): Partial<StateManagerProps> {
  return {
    theme: theme => ({ ...theme, colors: { ...theme.colors, primary: props.theme.colors.clr_1, neutral20: props.theme.colors.clr_0 } }),
    menuPlacement: props.menuPlacement || 'auto',
    styles: {
      ...(props.styles || {}),
      control: base => ({ ...base, height: props.isMulti ? undefined : '2.75em', minHeight: props.isMulti ? '2.75em' : undefined }),
      menu: base => ({ ...base, zIndex: 10001 }),
      placeholder: base => ({ ...base, fontSize: '85%' }),
      valueContainer: base => ({ ...base, paddingRight: 0 }),
      option: (base, optionProps) => ({ ...base, color: optionProps.isDisabled ? props.theme.colors.clr_0_light : base.color })
    }
  }
}

export const Select = injectTheme(function StyledSelect<T> (props: Props<T> & { theme?: DefaultTheme }) {
  return <UnstyledSelect { ...props } { ...getStyleOverrides(props) } placeholder={ props.placeholder ?? i18nScoped.t('select') } />
}) as any as typeof UnstyledSelect

export const CreatableSelect = injectTheme(function StyledCreatableSelect<T> (props: Props<T> & { theme?: DefaultTheme }) {
  return <UnstyledCreatable { ...props } { ...getStyleOverrides(props) } />
}) as any as typeof UnstyledCreatable

export const AsyncSelect = injectTheme(function StyledAsyncSelect<T> (props: Props<T> & { theme?: DefaultTheme, minInputLength?: number }) {
  const augmentedProps = { ...props }
  augmentedProps.noOptionsMessage ||= () => i18nScoped.t('no_result')

  if (props.minInputLength) {
    (augmentedProps as any).loadOptions = (inputValue: string, callback?: (results: T[]) => void) => {
      if (inputValue.length < props.minInputLength) {
        callback([])
      } else {
        return (props as any).loadOptions(inputValue, callback)
      }
    }

    augmentedProps.noOptionsMessage = ({ inputValue }) => {
      if (inputValue.length < props.minInputLength) return i18nScoped.t('min_input_length', { count: props.minInputLength })
      return i18nScoped.t('no_result')
    }
  }

  return <UnstyledAsync { ...augmentedProps } { ...getStyleOverrides(props) } />
}) as any as typeof UnstyledAsync & { defaultProps: { minInputLength: number } }
